/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-06-24 16:23:31
 * @LastEditors: yd
 * @LastEditTime: 2020-07-16 16:10:22
 */
import http from '../httpConfig'
// 高级参照管理

// 高级参照列表查询
export const getList = async(params) => {
        return await http.post('/api/prompt/list-prompt/v1', params)
    }
    // 高级参照业务列表
export const getBusinessList = (params = {}) => {
        params['~table~'] = 'mrbase_sys_prompt'
        return new Promise((resolve, reject) => {
            http.post('/api/prompt/business/findPrompt/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    // 高级参照详情
export const getDetail = async(params) => {
        return await http.post('/api/prompt/find-prompt/v1', params)
    }
    // 高级参照删除
export const getDetele = async(params) => {
        return await http.post('/api/prompt/delete-prompt/v1', params)
    }
    // 高级参照修改
export const getChange = async(params) => {
        return await http.post('/api/prompt/update-prompt/v1', params)
    }
    // 高级参照新增
export const getAdd = async(params) => {
    return await http.post('/api/prompt/add-prompt/v1', params)
}

export const refresh = async(params) => {
        return await http.post('/api/system/refresh-cache/v1', params)
    }
    // 查询多个来源表
export const mutipleTable = async(params = {}) => {
    // params['~table~'] = 'mrbase_sys_prompt'
    return await http.post('/api/prompt/resouce-table-prompt/v1', params)
}
export const accordingTableGetValue = async(params = {}) => {
    // params['~table~'] = 'mrbase_sys_prompt'
    return await http.post('/api/prompt/resouce-table-field-prompt/v1', params)
}